import type { AfterViewInit, OnDestroy } from '@angular/core';
import { Component, ElementRef, inject } from '@angular/core';
import { szebitInNumbers } from '../../../app.constants';
import { state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-szebit-in-numbers',
  templateUrl: './szebit-in-numbers.component.html',
  styleUrl: './szebit-in-numbers.component.scss',
  animations: [trigger('countUp', [state('void', style({})), transition('void => *', [])])],
})
export class SzebitInNumbersComponent implements AfterViewInit, OnDestroy {
  protected numbers = [0, 0, 0, 0];
  readonly #elementRef = inject(ElementRef);
  #observer?: IntersectionObserver;
  readonly #targets = [
    szebitInNumbers().szebitCount,
    szebitInNumbers().visitorsCount,
    szebitInNumbers().partnersCount,
    szebitInNumbers().daysCount,
  ];

  protected animate = false;

  ngAfterViewInit(): void {
    this.#observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          this.animate = true;
        } else {
          this.animate = false;
          this.numbers = [0, 0, 0, 0];
        }
      },
      { threshold: 0.2 },
    );
    this.#observer.observe(this.#elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.#observer?.disconnect();
  }

  protected animateNumbers(): void {
    for (let i = 0; i < this.#targets.length; i++) {
      this.#animateNumber(i);
    }
  }

  #animateNumber(i: number): void {
    const end = this.#targets[i];
    const duration = 1500;
    const startTime = performance.now();

    const step = (now: number): void => {
      const elapsed = now - startTime;
      if (elapsed < duration) {
        this.numbers[i] = Math.round(end * (elapsed / duration));
        requestAnimationFrame(step);
      } else {
        this.numbers[i] = end;
      }
    };
    requestAnimationFrame(step);
  }
}
